import React, { useState, useEffect, useRef } from 'react';
import rezeption from './assets/rezeption.webp';
import { useLanguage } from './LanguageContext';
import OptimizedImage from './components/OptimizedImage';

const Welcome = () => {
  const contentRef = useRef(null);
  const { t } = useLanguage();

  const handleNavClick = () => {
    const element = document.getElementById('leistungen');
    if (element) {
      const headerOffset = 60; // Adjust this value based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const containerStyle = {
    fontFamily: 'Sora, sans-serif',
  };

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
  };

  const imageContainerStyle = {
    width: '100%',
    position: 'relative',
    overflow: 'hidden'
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  };

  const headingStyle = {
    color: '#666666',
    fontWeight: '500',
    lineHeight: '1.1',
    letterSpacing: '-1px',
    fontSize: '1.8rem'
  };

  const headingContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem 0 0.8rem 0'
  };

  const textStyle = {
    color: '#666666',
    lineHeight: '1.6',
    fontWeight: '300',
    textAlign: 'center',
    padding: '0.5rem 1rem',
    fontSize: '1rem'
  };

  const signatureStyle = {
    color: '#666666',
    padding: '1rem 0 0.3rem 0',
    fontWeight: '500',
    fontSize: '1.2rem'
  };

  const buttonStyle = {
    backgroundColor: '#b9aba2',
    color: 'white',
    border: 'none',
    padding: '0.8rem 2rem',
    cursor: 'pointer',
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontWeight: '300',
    borderRadius: '5px'
  };

  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    margin: '1rem 0',
    borderRadius: '10px'
  };

  return (
    <section id="willkommen" style={containerStyle}>
      <style>{`
        .welcome-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
        }
        .welcome-image-container {
          width: 100%;
          position: relative;
          overflow: hidden;
        }
        @media (min-width: 700px) {
          .welcome-layout {
            display: flex;
            flex-direction: row;
            align-items: stretch;
            width: 100%;
            min-height: 480px;
            gap: 40px;
          }
          .welcome-content {
            flex: 1 1 0;
            align-items: flex-start;
            justify-content: center;
            max-width: 600px;
            margin: 0;
          }
          .welcome-image-container {
            flex: 1 1 0;
            width: 0;
            min-width: 350px;
            padding: 0;
            margin: auto;
            display: flex;
            align-items: stretch;
            height: auto;
          }
          .welcome-image-container img, .welcome-image-container .optimized-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }
        }
      `}</style>
      <div className="welcome-layout">
        <div style={contentStyle} ref={contentRef} className="welcome-content">
          <div style={headingContainerStyle}>
          <h1 style={headingStyle}>{t('welcome')}</h1>
          </div>
            <p style={textStyle}>
            {t('welcomeText1')}
            </p>
            <p style={textStyle}>
            {t('welcomeText2')}
            </p>
            <p style={signatureStyle}>{t('welcomeSignature')}</p>
            <div style={buttonContainerStyle}>
              <button style={buttonStyle} onClick={() => handleNavClick()}>{t('learnMore')}</button>
            </div>
          </div>
        <div className="welcome-image-container">
          <OptimizedImage 
            src={rezeption} 
            alt="Physiotherapiezentrum Rezeption" 
            style={imageStyle}
          />
        </div>
      </div>
    </section>
  );
};

export default Welcome; 